<template>
    <div class="container" v-if="isUniqueSite || !displayModalChoixSite">
        <div class="title-container">
            <h1>
                {{ $t('preventif.suivi.title') }}
                <ReglePastille cle="interventionPreventive.definition" />
                <ReglePastille cle="planningPreventif.portee" />
            </h1>
        </div>
        <div class="filter">
            <h2>{{ $t('title.filter') }}</h2>
            <div class="filter-and-button-container">
                <div class="filter-container">
                    <div class="switch-container" v-if="!isUniqueSite">
                        <TextInput :label="$t('preventive.filter.site')" v-model="siteFilter" />
                        <ReglePastille cle="planningPreventif.filtreSiteUnique" />
                    </div>
                    <div class="button-container" v-if="!isUniqueSite">
                        <ButtonBlue
                            class="button-confirm btn"
                            name="confirm"
                            :onClick="changerSite"
                            :text="$t('bouton.choix.site')"/>
                    </div>
                    <div class="switch-container">
                        <span class="switch-label" id="label-vision">
                            {{ $t('preventive.filter.vision') }}
                            <ReglePastille cle="planningPreventif.visionPeriode" />
                        </span>
                        <div class="switch-wrapper" @click.stop="switchVision" @keydown.enter.prevent="switchVision" @keydown.space.prevent="switchVision" tabindex="0" role="button" aria-labelledby="label-vision">
                            <span class="switch-option-left" aria-hidden="true">
                                {{ $t('preventive.filter.mensuelVision') }}
                            </span>
                            <Switch :active="isWeek" />
                            <span class="switch-option-right" aria-hidden="true">
                                {{ $t('preventive.filter.weekVision') }}
                            </span>
                        </div>
                    </div>
                    <div class="switch-container">
                        <span class="switch-label" id="label-intervention">
                            {{ $t('preventive.filter.intervention') }}
                            <ReglePastille cle="planningPreventif.visionReel" />
                        </span>
                        <div class="switch-wrapper" @click.stop="switchIntervention" @keydown.enter.prevent="switchIntervention" @keydown.space.prevent="switchIntervention" tabindex="0" role="button" aria-labelledby="label-intervention">
                            <span class="switch-option-left" aria-hidden="true">
                                {{ $t('preventive.filter.previsionnel') }}
                            </span>
                            <Switch :active="isReel" />
                            <span class="switch-option-right" aria-hidden="true">
                                {{ $t('preventive.filter.reel') }}
                            </span>
                        </div>
                    </div>

                    <div class="width">
                        <span class="switch-label">
                            {{ $t('preventive.filter.goto') }}
                        </span>
                        <AnneeChips @select="showCompleteYear" />
                    </div>
                </div>
                <div class="button-container">
                    <BorderedIconButton @click="exportXls" :imgUrl="iconeXls" :title="$t('list.export')"/>
                </div>
            </div>
            <!-- Ajout sur une seconde ligne: Switch S�lection (gauche), compteur + bouton t�l�charger (droite) -->
            <div class="selection-actions-row">
                <!-- Gauche: switch s�lection -->
                <div class="switch-container">
                    <span class="switch-label" id="label-selection-rapport">
                        {{ $t('preventive.filter.selectionRapport') }}
                        <ReglePastille cle="planningPreventif.selectionRapports" />
                    </span>
                    <div class="switch-wrapper" @click.stop="toggleSelectionMode" @keydown.enter.prevent="toggleSelectionMode" @keydown.space.prevent="toggleSelectionMode" tabindex="0" role="button" aria-labelledby="label-selection-rapport">
                        <span class="switch-option-left" aria-hidden="true">
                            {{ $t('preventive.filter.selectionRapportNon') }}
                        </span>
                        <Switch :active="selectionMode" />
                        <span class="switch-option-right" aria-hidden="true">
                            {{ $t('preventive.filter.selectionRapportOui') }}
                        </span>
                    </div>
                </div>
                <!-- Droite: compteur coll� au bouton + bouton t�l�charger la s�lection -->
                <div class="right-actions">
                    <span v-if="selectionMode" class="selection-counter">
                        {{ $t('preventive.filter.rapportSelectionne', selectedCells.length, { count: selectedCells.length }) }}
                    </span>
                    <BorderedIconButton
                        v-if="selectionMode && selectedInterventionIds.length > 0"
                        @click="downloadSelected"
                        :imgUrl="iconeDownload"
                        :title="$t('list.download.selection')"
                    />
                </div>
            </div>
        </div>
        <div class="planning-container" @scroll="handleScroll" ref="siteListPlannning">
            <TreeGrid
                @next="next"
                @previous="previous"
                @emitOpenModal="openModal"
                v-if="grid"
                :isWeek="isWeek"
                :gridData="grid"
                :gridHeader="gridHeader"
                :isLoading="loading && isEmptyList"
                :gridHeaderAll="gridHeaderAll"
                :other-data-loading="!isAllData && loading"
                :selection-mode="selectionMode"
                :selected-report-ids="documentListToDownload"
                :selected-ui-ids="selectedUiIds"
                @cellClick="onCellClick"
            />
        </div>
        <WaitingModal v-if="isExportXlsLoading || isRapportLoading"/>
    </div>
    <EquipementModal v-if="modaleActive" :preventif="true"/>
    <ModalChoixSite v-if="displayModalChoixSite && !isUniqueSite"
                    @cancel="modalChoixSiteCancel"
                    @valider="validerSite"
                    :selected-site="selectedSite"
                    :selected-sites="null"
                    :is-multi-site="false"
                    :inclure-termines="true"
                    :sites-autorises="sitesDashboard"
                    :sous-titre="$t('preventif.suivi.modal.choix.titre')"
                    regle-cle="planningPreventif.choixUnOuTousSites"/>
    <ModalChoixNomZip v-if="showModalNomZip"
                      @cancel="showModalNomZip = false"
                      @download="downloadDocuments"/>
</template>

<script lang="ts">
import TreeGrid from '@/modules/Preventif/components/TreeGrid.vue';
import { defineComponent, onMounted, ref } from 'vue';
import Switch from '@/components/ui-components/Switch.vue';
import TextInput from '@/components/ui-components/TextInput.vue';
import dayjs from 'dayjs';
import { SortType } from '@/models/SortType';
import { PreventifActions } from '../store/action-types';
import { PREVENTIF } from '../store/mutation-types';
import EquipementModal from '../components/EquipementModal.vue';
import AnneeChips from '@/modules/Preventif/components/AnneeChips.vue';
import { EquipementInterventionsActions } from '@/modules/Preventif/store/modules/action-types';
import { EQUIPEMENT_INTERVENTIONS } from '@/modules/Preventif/store/modules/mutation-types';
import ButtonBlue from '@/components/ui-components/ButtonBlue.vue';
import { Site } from '@/models/Site';
import { store } from '@/plugins/store';
import { INTERVENTION } from '@/modules/Intervention/store/mutation-types';
import { SiteListActions } from '@/modules/SiteList/store/action-types';
import SiteListService, { SiteSearchDTO } from '@/modules/SiteList/service/SiteListService';
import BorderedIconButton from '@/components/ui-components/BorderedIconButton.vue';
import WaitingModal from '@/components/ui-components/WaitingModal.vue';
import ModalChoixSite from '@/modules/Common/components/ModalChoixSite.vue';
import ModalChoixNomZip from '@/components/ui-components/ModalChoixNomZip.vue';
import { RapportActions } from '@/modules/Rapport/store/action-types';
import ReglePastille from '@/components/regles/ReglePastille.vue';

const now = new Date();

export default defineComponent({
    data(): {
        isOpenModalEquipement: boolean;
        filter: { dateDebut: string; dateFin: string };
        lastDateFinLoaded: string;
        lastDateDebutLoaded: string;
        dateDebutMois: string;
        dateFinMois: string;
        dateDebutSemaine: string;
        dateFinSemaine: string;
        modalData: {
            tableData: any[];
            tableHeader: any[];
            isLoading: boolean;
            count: number;
            sort?: { sortData: string; sortType: SortType };
        };
        currentEquipmentId?: string;
        displayModalChoixSite: boolean;
        siteFilter?: string;
        typeFiltreUniquesite?: boolean;
        site?: Site;
        selectionMode: boolean;
        selectedCells: any[];
        documentListToDownload: string[];
        showModalNomZip: boolean;
        isRapportLoading: boolean;
        sitesDashboard: Site[];
    } {
        return {
            isOpenModalEquipement: false,
            filter: { dateDebut: '', dateFin: '' },
            lastDateFinLoaded: '',
            lastDateDebutLoaded: '',
            dateDebutMois: dayjs(now).subtract(5, 'month').startOf('month').format('YYYY-MM-DD'),
            dateFinMois: dayjs(now).add(6, 'month').endOf('month').format('YYYY-MM-DD'),
            dateDebutSemaine: dayjs(now).subtract(5, 'week').startOf('week').add(1, 'day').format('YYYY-MM-DD'),
            dateFinSemaine: dayjs(now).add(6, 'week').endOf('week').subtract(1, 'day').format('YYYY-MM-DD'),
            modalData: {
                tableData: [],
                tableHeader: [],
                isLoading: true,
                count: 0,
                sort: undefined,
            },
            currentEquipmentId: undefined,
            displayModalChoixSite: true,
            typeFiltreUniquesite: true,
            site: undefined,
            selectionMode: false,
            selectedCells: [],
            documentListToDownload: [],
            showModalNomZip: false,
            isRapportLoading: false,
            sitesDashboard: []
        };
    },
    components: {
        ModalChoixSite,
        WaitingModal,
        AnneeChips,
        TreeGrid,
        Switch,
        EquipementModal,
        TextInput,
        ButtonBlue,
        BorderedIconButton,
        ModalChoixNomZip,
        ReglePastille,
    },
    beforeMount() {
        this.$store.dispatch(`siteList/${SiteListActions.RESET_LIST}`);
        this.$store.dispatch(`siteList/${SiteListActions.GET_SITE_LIST}`, new SiteSearchDTO(0, '', false, true));


        const siteIdsDashboard: number[] = ((this.$route.query.siteIds as string) || '')
            .split(',')
            .filter(Boolean)
            .map(Number);

        SiteListService.getSiteList(new SiteSearchDTO(0, '', true, true)).then(res => {
            this.displayModalChoixSite = res.data.length !== 1;
            this.site = res.data;

            if (siteIdsDashboard.length > 0) {
                const sitesDashboard: Site[] = res.data.filter((s: Site) => siteIdsDashboard.includes(s.id));
                if (sitesDashboard.length === 1) {
                    // un seul site : planning direct sur ce site
                    this.site = sitesDashboard[0];
                    this.displayModalChoixSite = false;
                } else if (sitesDashboard.length === res.data.length) {
                    // tous les sites du compte : planning direct "Tous mes sites"
                    this.site = undefined;
                    this.displayModalChoixSite = false;
                } else {
                    // plusieurs sites : modale limitée aux sites du dashboard
                    this.sitesDashboard = sitesDashboard;
                    this.displayModalChoixSite = true;
                }
            }

            if (!this.displayModalChoixSite) {
                this.reload();
            }
        });
        this.$store.commit(PREVENTIF.SET_LAST_SITE_ID, undefined);
        this.site = this.selectedSite;
    },
    setup() {
        const siteListPlannning = ref<Element>();

        onMounted(() => {
            siteListPlannning.value;
        });

        return {
            siteListPlannning,
        };
    },
    methods: {
        toggleSelectionMode() {
            this.selectionMode = !this.selectionMode;
            if (!this.selectionMode) {
                // reset selection when leaving selection mode
                this.selectedCells = [];
                this.documentListToDownload = [];
            }
        },
        async downloadSelected() {
            try {
                const interventionIds = this.selectedInterventionIds;
                if (!interventionIds || interventionIds.length === 0) {
                    return;
                }
                if (interventionIds.length === 1) {
                    const payload: any = { interventionIds, chantierIds: [] };
                    this.isRapportLoading = true;
                    await this.$store.dispatch(`rapportState/${RapportActions.GET_RAPPORT_PDF}`, payload);
                    this.isRapportLoading = false;
                    // reset s�lection
                    this.selectedCells = [];
                    this.documentListToDownload = [];
                    // d�sactiver le mode s�lection apr�s t�l�chargement
                    this.selectionMode = false;
                } else {
                    this.showModalNomZip = true;
                }
            } catch (e) {
                // eslint-disable-next-line no-console
                console.warn('[Preventif] Erreur lors du t�l�chargement de la s�lection', e);
            }
        },
        async downloadDocuments(nomZip: string) {
            try {
                const interventionIds = this.selectedInterventionIds;
                const payload: any = { interventionIds, chantierIds: [], nomZip };
                this.isRapportLoading = true;
                await this.$store.dispatch(`rapportState/${RapportActions.GET_RAPPORT_PDF}`, payload);
                this.isRapportLoading = false;
            } finally {
                // reset et fermeture de la modale
                this.showModalNomZip = false;
                this.selectedCells = [];
                this.documentListToDownload = [];
                // d�sactiver le mode s�lection apr�s t�l�chargement multiple
                this.selectionMode = false;
            }
        },
        onCellClick(payload: any) {
            // payload: { rowId, period }
            if (!this.selectionMode) return;
            const key = `${payload.rowId}-${payload.period?.id ?? payload.period?.dateDebut ?? ''}`;
            const idx = this.selectedCells.findIndex((p: any) => p.__key === key);
            if (idx >= 0) {
                this.selectedCells.splice(idx, 1);
            } else {
                this.selectedCells.push({ ...payload, __key: key });
            }
            // miroir de Rapport.vue: g�rer une liste d'identifiants s�lectionn�s
            if (payload?.reportId) {
                const docIdx = this.documentListToDownload.findIndex((id: string) => id === payload.reportId);
                if (docIdx >= 0) {
                    this.documentListToDownload.splice(docIdx, 1);
                } else {
                    this.documentListToDownload.push(payload.reportId);
                }
            }

        },
        showCompleteYear(annee: string) {
            const debut = dayjs(annee + '-01-01').format('YYYY-MM-DD');
            const fin = dayjs(annee + '-12-31').format('YYYY-MM-DD');
            this.lastDateDebutLoaded = debut;
            this.lastDateFinLoaded = fin;
            this.dateDebutMois = debut;
            this.dateFinMois = fin;
            this.dateDebutSemaine = dayjs(debut).startOf('week').add(1, 'day').format('YYYY-MM-DD');
            this.dateFinSemaine = dayjs(debut).add(12, 'week').endOf('week').subtract(1, 'day').format('YYYY-MM-DD');
            this.getData(debut, fin, this.site);
        },
        openModal(id: string) {
            this.$store.commit(EQUIPEMENT_INTERVENTIONS.SET_ACTIVE, true);
            this.$store.commit(EQUIPEMENT_INTERVENTIONS.SET_EQUIPEMENT_ID, id);
            this.$store.dispatch(EquipementInterventionsActions.GET_EQUIPEMENT_INTERVENTIONS, {
                phaseIds: [id],
                page: 0,
            });
        },
        modalEquipementCancel() {
            this.isOpenModalEquipement = false;
            this.modalData = { tableData: [], tableHeader: [], isLoading: true, count: 0, sort: undefined };
        },
        switchVision() {
            this.$store.commit(PREVENTIF.SWITCH_PERIODICITE);
            this.reload();
        },
        switchIntervention() {
            this.$store.commit(PREVENTIF.SWITCH_PREVISIONNEL_REEL);
            this.reload();
        },
        reload(){
            if(this.isWeek){
                this.lastDateDebutLoaded = this.dateDebutSemaine;
                this.lastDateFinLoaded = this.dateFinSemaine;
                this.getData(this.dateDebutSemaine, this.dateFinSemaine, this.site);
            } else {
                this.lastDateDebutLoaded = this.dateDebutMois;
                this.lastDateFinLoaded = this.dateFinMois;
                this.getData(this.dateDebutMois, this.dateFinMois, this.site);
            }
        },
        getData(dateDebut: string, dateFin: string, site?: Site, isForInfiniteScroll?: boolean): Promise<boolean> {
            const lastSiteId : number | undefined = this.getLastSiteId;
            return this.$store.dispatch(PreventifActions.GET_PREVENTIF, { dateDebut, dateFin, site, lastSiteId, isForInfiniteScroll, isMonoSite: this.isUniqueSite });
        },
        next() {
            if (!this.loading) {
                this.loading = true;
                if (this.gridHeaderAll.length - this.nbPeriodesAffichees - this.page >= this.nbPeriodesStep) {
                    this.$store.commit(PREVENTIF.SET_PAGE, this.page + this.nbPeriodesStep);
                    this.$store.commit(PREVENTIF.SET_DISPLAY);
                } else {
                    let dateDebut: string, dateFin: string;
                    if (this.isWeek) {
                        dateDebut = dayjs(this.lastDateFinLoaded).add(1, 'day').format('YYYY-MM-DD');
                        dateFin = dayjs(this.lastDateFinLoaded).add(this.nbPeriodesStep, 'week').format('YYYY-MM-DD');
                    } else {
                        dateDebut = dayjs(this.lastDateFinLoaded).add(1, 'day').startOf('month').format('YYYY-MM-DD');
                        dateFin = dayjs(this.lastDateFinLoaded).add(this.nbPeriodesStep, 'month').endOf('month').format('YYYY-MM-DD');
                    }
                    this.$store.dispatch(PreventifActions.NEXT, {
                        dateDebut,
                        dateFin,
                        site: this.site,
                        isMonoSite: this.isUniqueSite
                    }).then((res: boolean) => {
                        if (res) this.lastDateFinLoaded = dateFin;
                    });
                }
                this.loading = false;
            }
        },
        previous() {
            if (!this.loading) {
                this.loading = true;
                if (this.page >= this.nbPeriodesStep) {
                    this.$store.commit(PREVENTIF.SET_PAGE, this.page - this.nbPeriodesStep);
                    this.$store.commit(PREVENTIF.SET_DISPLAY);
                } else {
                    let dateDebut: string, dateFin: string;
                    if (this.isWeek) {
                        dateDebut = dayjs(this.lastDateDebutLoaded).subtract(this.nbPeriodesStep, 'week').format('YYYY-MM-DD');
                        dateFin = dayjs(this.lastDateDebutLoaded).subtract(1, 'day').format('YYYY-MM-DD');
                    } else {
                        dateDebut = dayjs(this.lastDateDebutLoaded).subtract(this.nbPeriodesStep, 'month').format('YYYY-MM-DD');
                        dateFin = dayjs(this.lastDateDebutLoaded).subtract(1, 'day').format('YYYY-MM-DD');
                    }
                    this.$store.dispatch(PreventifActions.PREV, {
                        dateDebut,
                        dateFin,
                        site: this.site,
                        isMonoSite: this.isUniqueSite
                    }).then((res: boolean) => {
                        if (res) this.lastDateDebutLoaded = dateDebut;
                    });
                }
                this.loading = false;
            }
        },
        validerSite(site: Site) : void {
            this.site = site;
            store.commit(INTERVENTION.SET_SITE, site);
            this.reload();
            this.displayModalChoixSite = false;
        },
        modalChoixSiteCancel(): void {
            this.site = undefined;
            this.reload();
            this.displayModalChoixSite = false;
        },
        changerSite() : void {
            store.commit(PREVENTIF.RESET);
            this.displayModalChoixSite = !this.displayModalChoixSite;
        },
        exportXls() : void {
            this.getXls(this.lastDateDebutLoaded, this.lastDateFinLoaded, this.site);
        },
        getXls(dateDebut: string, dateFin: string, site?: Site) : void{
            this.$store.dispatch(PreventifActions.GET_XLS, { dateDebut, dateFin, site, isMonoSite: this.isUniqueSite });
        },
        handleScroll() {
            const height = this.siteListPlannning?.clientHeight ?? 0;
            const top = this.siteListPlannning?.scrollTop ?? 0;
            const max = this.siteListPlannning?.scrollHeight ?? 0;
            if (max - top <= height * 1.5 && !this.isAllData && !this.loading) {
                if(this.isWeek){
                    this.getData(this.dateDebutSemaine, this.dateFinSemaine, this.site, true);
                } else {
                    this.getData(this.dateDebutMois, this.dateFinMois, this.site, true);
                }
            }
        }
    },
    computed: {
        iconeXls() {
            return require('@/assets/img/xls.svg');
        },
        isEmptyList() : boolean {
            if (this.$store.getters.getPreventif === undefined) {
                return true;
            }
            return this.$store.getters.getPreventif.length === 0;
        },
        grid() {
            return this.$store.getters.getDisplayPreventif;
        },
        page(): number {
            return this.$store.getters.getPagePreventif;
        },
        nbPeriodesAffichees(): number {
            return this.$store.getters.getNbPeriodesAffichees;
        },
        nbPeriodesStep(): number {
            return this.$store.getters.getNbPeriodesStep;
        },
        gridHeaderAll(): { dateDebut: string; dateFin: string }[] {
            return this.$store.getters.getHeaderPreventif;
        },
        gridHeader(): { dateDebut: string; dateFin: string }[] {
            return this.$store.getters.getDisplayHeaderPreventif;
        },
        isWeek(): boolean {
            return this.$store.getters.isPeriodiciteHebdomadaire;
        },
        loading(): boolean {
            return this.$store.getters.getIsLoadingPreventif;
        },
        isReel(): boolean {
            return this.$store.getters.isReel;
        },
        modaleActive(): boolean {
            return this.$store.getters.getEquipementInterventionsActive;
        },
        siteFilter: {
            get(): string {
                return this.$store.getters.getSiteFilter;
            },
            set(search: string) {
                this.$store.commit(PREVENTIF.FILTER_BY_SITE, search);
            },
        },
        selectedSite() {
            return store.getters.getInterventionSiteValue;
        },
        isExportXlsLoading(): boolean {
            return store.getters.getXlsInterventionsPreventivesLoading;
        },
        isAllData(): boolean {
            return store.getters.isAllData;
        },
        getLastSiteId(): number | undefined {
            return store.getters.getLastSiteId;
        },
        isUniqueSite(): boolean {
            return store.getters.isUniqueSite;
        },
        selectedUiIds(): string[] {
            return this.selectedCells.map((c: any) => c.uiId).filter((id: string | undefined) => !!id);
        },
        selectedInterventionIds(): number[] {
            try {
                return Array.from(
                    new Set(
                        this.selectedCells
                            .map((c: any) => c?.interventionId)
                            .filter((id: any) => id !== undefined && id !== null)
                    )
                );
            } catch (e) {
                return [];
            }
        },
        iconeDownload() {
            return require('@/assets/img/pdf-icon.svg');
        }
    },
});
</script>

<style scoped>
/* Ligne 2: zone d�di�e aux actions de s�lection */
.selection-actions-row {
    display: flex;
    align-items: center;
    background: white;
    border-radius: 6px;
    padding: 8px 16px;
    margin-top: 8px;
}
.selection-actions-row .switch-container {
    margin: 0;
    flex: 0 0 auto;
}
/* Compteur (par d�faut � droite, coll� au bouton) */
.selection-counter {
    margin-right: 8px;
    font-weight: 600;
}
/* Ancien style si jamais utilis� ailleurs pour le centrage */
.selection-counter.center {
    flex: 1;
    text-align: center;
}

/* Bouton � droite */
.right-actions {
    flex: 1;
    display: flex;
    justify-content: flex-end;
}
</style>

<style scoped>
.container {
    display: flex;
    flex-direction: column;
    flex: 1;
    padding: 24px;
    padding-bottom: 0;
}
.title-container h1 {
    color: var(--color-principal);
    font-size: var(--font-size-large);
    font-weight: var(--font-weight-600);
    margin-bottom: 15px;
    margin-top: 0;
}
.filter {
    padding: 8px 16px;
    background: white;
    border-radius: 6px;
    margin-bottom: 8px;
    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, .2), 0 2px 2px rgba(0, 0, 0, .14), 0 1px 5px rgba(0, 0, 0, .12);
}
.filter h2 {
    font-weight: 500;
    font-size: 18px;
    color: var(--color-principal);
    margin: 0 0 12px 0;
}
.switch-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
}
.switch-wrapper {
    display: flex;
    align-items: center;
    cursor: pointer;
}
.switch-option-left {
    margin-right: 8px;
    color: rgba(0, 0, 0, 0.6);
}
.switch-option-right {
    margin-left: 8px;
    color: rgba(0, 0, 0, 0.6);
}
.filter-container {
    display: flex;
    justify-content: flex-start;
    gap: 5%;
    width: 100%;
    box-shadow: none;
}
.width {
    width: 13%;
}
.button-confirm {
    right: 16px;
    box-shadow: none;
}
.btn {
    width: 90px;
    border-radius: 5px;
    cursor: pointer;
    height: 40px;
}
.button-container {
    display: flex;
    justify-content: space-between;
    text-align: right;
    height: 38px;
}
.filter-and-button-container{
    display: flex;
}
.planning-container {
    max-height: calc(100vh - 335px);
    overflow-y: auto;
    overflow-x: hidden;
    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, .2), 0 2px 2px rgba(0, 0, 0, .14), 0 1px 5px rgba(0, 0, 0, .12);
}
.selection-counter {
    margin-right: 12px;
    align-self: center;
    font-weight: 600;
    color: var(--color-principal);
}
</style>
